const urlName = '/raas/v1/question'
export default API => ({
    // 试题列表
    getQuestionList(data) {
        // pageNum,pageSize,title,status,type
        //${pageSize}&pageNum=${pageNum}&title=${title}&status=${status}&type=${type}
        return API({
            url: `${urlName}/getQuestionList` ,
            method:  'post',
            data
        });
    },
    // 试题删除
    questionDelete(data){
        return API({
            url: `${urlName}/delete` ,
            method:  'post',
            data
        });
    },
    // 试题预览/编辑
    questionPreview(id){
        return API({
            url: `${urlName}/findById?id=${id}` ,
            method:  'get',
        });
    },
    // 试题保存
    questionSave(data){
        return API({
            url: `${urlName}/save` ,
            method:  'post',
            data
        });
    },
    // 试题发布/批量发布接口
    questionPublish(data){
        return API({
            url: `${urlName}/releashQuestion` ,
            method:  'post',
            data
        });
    }
})
